import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { useTranslation } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

export function CookieConsentBanner() {
  const { consentStatus, acceptCookies, declineCookies } = useCookieConsent();
  const { t } = useTranslation();

  // Don't show if consent already given
  if (consentStatus !== 'pending') {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      >
        <div className="mx-auto max-w-4xl">
          <div className="relative rounded-lg border border-border bg-card p-4 md:p-6 shadow-lg backdrop-blur-sm">
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div className="flex items-start gap-3">
                <div className="rounded-full bg-primary/10 p-2">
                  <Cookie className="h-5 w-5 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-foreground">
                    {t('gdpr.cookieTitle') || 'Cookie Preferences'}
                  </h3>
                  <p className="mt-1 text-sm text-muted-foreground">
                    {t('gdpr.cookieDescription') || 
                      'We use cookies to analyze site usage and improve your experience. Your data is never sold to third parties.'}
                  </p>
                  <Link 
                    to="/privacy" 
                    className="mt-1 inline-block text-sm text-primary hover:underline"
                  >
                    {t('gdpr.learnMore') || 'Learn more about our privacy practices'}
                  </Link>
                </div>
              </div>
              
              <div className="flex items-center gap-2 shrink-0">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={declineCookies}
                  className="gap-1"
                >
                  <X className="h-4 w-4" />
                  {t('gdpr.decline') || 'Decline'}
                </Button>
                <Button
                  size="sm"
                  onClick={acceptCookies}
                >
                  {t('gdpr.accept') || 'Accept'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
